// src/context/BusinessCreationContext.js
import { createContext, useContext, useState } from "react";

const BusinessCreationContext = createContext();

export function BusinessCreationProvider({ children }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    password: "",
    phone: "",
    businessName: "",
    website: "",
    services: [],
    teamSize: "",
    location: "",
    noAddress: false,
    currentSoftware: "",
    referral: "",
  });

  const updateForm = (updates) => {
    setFormData((prev) => ({ ...prev, ...updates }));
  };

  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      password: "",
      phone: "",
      businessName: "",
      website: "",
      services: [],
      teamSize: "",
      location: "",
      noAddress: false,
      currentSoftware: "",
      referral: "",
    });
  };

  return (
    <BusinessCreationContext.Provider value={{ formData, updateForm, resetForm }}>
      {children}
    </BusinessCreationContext.Provider>
  );
}

export function useBusinessCreation() {
  return useContext(BusinessCreationContext);
}
